/* JB 回遊用の商品列（snippets/jb-xsell-row.liquid）
   - PCの左右矢印（イベントは document に委譲。カートドロワーは中身が入れ替わるため）
   - 商品ページ「あわせて読みたい本」: Shopify のおすすめを取得して先頭に差し込み、残りをコレクションの本で埋める
   - カートドロワーの「カートに入れる」: /cart/add.js で追加し、on:cart:change でドロワーを更新
   - GA4: xs_product_click / xs_more_click / xs_add_to_cart（row = 列の名前）。本選びナビと同じく dataLayer に積み、gtag があれば送る */
(function () {
  if (window.__jbXsell) return;
  window.__jbXsell = true;

  function track(name, params) {
    try {
      var payload = Object.assign({ event: name }, params);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) { /* 計測の失敗で操作を止めない */ }
  }

  function updateArrows(vp) {
    var wrap = vp.parentElement;
    var prev = wrap.querySelector('[data-jb-xs-prev]');
    var next = wrap.querySelector('[data-jb-xs-next]');
    if (!prev || !next) return;
    prev.disabled = vp.scrollLeft <= 2;
    next.disabled = vp.scrollLeft >= vp.scrollWidth - vp.clientWidth - 2;
  }
  function updateAll() {
    document.querySelectorAll('[data-jb-xs-viewport]').forEach(updateArrows);
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-jb-xs-viewport]')) updateArrows(t);
  }, true);
  window.addEventListener('resize', updateAll);

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-jb-xs-prev], [data-jb-xs-next]');
    if (arrow) {
      var vp = arrow.parentElement.querySelector('[data-jb-xs-viewport]');
      if (vp) vp.scrollBy({ left: (arrow.hasAttribute('data-jb-xs-prev') ? -1 : 1) * vp.clientWidth * 0.8 });
      return;
    }

    var add = e.target.closest('[data-jb-xs-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var row = add.closest('[data-jb-xs-row]');
      add.disabled = true;
      add.textContent = '追加中…';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-jb-xs-add')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function () {
        add.textContent = '追加しました';
        track('xs_add_to_cart', { row: row ? row.getAttribute('data-jb-xs-row') : '', product_id: add.closest('[data-jb-xs-id]').getAttribute('data-jb-xs-id') });
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      }).catch(function () {
        add.disabled = false;
        add.textContent = '追加できませんでした';
      });
      return;
    }

    var link = e.target.closest('[data-jb-xs-click], [data-jb-xs-more]');
    if (link) {
      var r = link.closest('[data-jb-xs-row]');
      var item = link.closest('[data-jb-xs-id]');
      track(link.hasAttribute('data-jb-xs-more') ? 'xs_more_click' : 'xs_product_click', {
        row: r ? r.getAttribute('data-jb-xs-row') : '',
        product_id: item ? item.getAttribute('data-jb-xs-id') : ''
      });
    }
  });

  // 商品ページ：おすすめを先頭に、コレクションの本で補う（重複は除く）
  function loadRecs(row) {
    var url = row.getAttribute('data-jb-xs-recs');
    var limit = Number(row.getAttribute('data-jb-xs-limit')) || 10;
    var vp = row.querySelector('[data-jb-xs-viewport]');
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var recs = Array.prototype.slice.call(doc.querySelectorAll('[data-jb-xs-recs-result] [data-jb-xs-id]'));
      var fill = Array.prototype.slice.call(vp.querySelectorAll(':scope > [data-jb-xs-id]'));
      var seen = {};
      var list = [];
      recs.concat(fill).forEach(function (el) {
        var id = el.getAttribute('data-jb-xs-id');
        if (seen[id] || list.length >= limit) return;
        seen[id] = true;
        list.push(el);
      });
      if (!list.length) { row.remove(); return; }
      var more = vp.querySelector('[data-jb-xs-more]');
      fill.forEach(function (el) { el.remove(); });
      list.forEach(function (el) { vp.insertBefore(document.importNode(el, true), more); });
      vp.scrollLeft = 0;
      updateArrows(vp);
    }).catch(function () {
      if (!vp.querySelector('[data-jb-xs-id]')) row.remove();
    });
  }

  function init() {
    document.querySelectorAll('[data-jb-xs-recs]').forEach(loadRecs);
    updateAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('on:cart:after-merge', updateAll);
  document.addEventListener('on:cart-drawer:after-open', updateAll);
})();
